export const POLICY_STATUSES = {
  ACTIVE: 'ACTIVE',
  NOT_ACTIVE: 'NOT_ACTIVE',
};
export const PAYMENT_STATUS = {
  UNDEFINED: 'UNDEFINED',
  UPCOMING: 'UPCOMING',
  OVERDUE: 'OVERDUE',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
};
export const INVITATION_STATUS = {
  NOT_SENT: 'NOT_SENT',
  SENDING: 'SENDING',
  SENT: 'SENT',
  SCHEDULED: 'SCHEDULED',
};

export const POLICY_STATUSES_TEXTS = {
  [POLICY_STATUSES.ACTIVE]: 'adminTitles.active',
  [POLICY_STATUSES.NOT_ACTIVE]: 'adminTitles.inactive',
};
export const POLICY_STATUSES_COLORS = {
  [POLICY_STATUSES.ACTIVE]: 'rgba(88, 219, 77, 1)',
  [POLICY_STATUSES.NOT_ACTIVE]: 'rgba(255, 141, 122, 1)',
};
export const PAYMENT_STATUSES_TEXTS = {
  [PAYMENT_STATUS.COMPLETED]: 'policies.options.COMPLETED',
  [PAYMENT_STATUS.OVERDUE]: 'policies.options.OVERDUE',
  [PAYMENT_STATUS.CANCELED]: 'policies.options.CANCELED',
  [PAYMENT_STATUS.UPCOMING]: 'policies.options.UPCOMING',
  [PAYMENT_STATUS.UNDEFINED]: 'policies.options.UNDEFINED',
};
export const PAYMENT_STATUSES_COLORS = {
  [PAYMENT_STATUS.COMPLETED]: 'rgba(88, 219, 77, 1)',
  [PAYMENT_STATUS.OVERDUE]: 'rgba(255, 141, 122, 1)',
  [PAYMENT_STATUS.CANCELED]: 'rgba(255, 189, 19, 1)',
  [PAYMENT_STATUS.UPCOMING]: 'rgba(199, 199, 199, 1)',
};
export const INVITATION_STATUSES_TEXTS = {
  [INVITATION_STATUS.SENT]: 'policies.options.SENT',
  [INVITATION_STATUS.SENDING]: 'policies.options.SENDING',
  [INVITATION_STATUS.NOT_SENT]: 'policies.options.NOT_SENT',
  [INVITATION_STATUS.SCHEDULED]: 'policies.options.SCHEDULED',
};
export const INVITATION_STATUSES_COLORS = {
  [INVITATION_STATUS.SENT]: 'rgba(88, 219, 77, 1)',
  [INVITATION_STATUS.SENDING]: 'rgba(84, 163, 255, 1)',
  [INVITATION_STATUS.NOT_SENT]: 'rgba(255, 141, 122, 1)',
  [INVITATION_STATUS.SCHEDULED]: 'rgba(255, 189, 19, 1)',
};
export const POLICY_STATUSES_OPTIONS = [
  {
    id: POLICY_STATUSES.ACTIVE,
    name: POLICY_STATUSES_TEXTS[POLICY_STATUSES.ACTIVE],
    color: POLICY_STATUSES_COLORS[POLICY_STATUSES.ACTIVE]
  },
  {
    id: POLICY_STATUSES.NOT_ACTIVE,
    name: POLICY_STATUSES_TEXTS[POLICY_STATUSES.NOT_ACTIVE],
    color: POLICY_STATUSES_COLORS[POLICY_STATUSES.NOT_ACTIVE]
  },
];
export const PAYMENT_STATUSES_OPTIONS = [
  {
    id: PAYMENT_STATUS.COMPLETED,
    name: PAYMENT_STATUSES_TEXTS[PAYMENT_STATUS.COMPLETED],
    color: PAYMENT_STATUSES_COLORS[PAYMENT_STATUS.COMPLETED]
  },
  {
    id: PAYMENT_STATUS.OVERDUE,
    name: PAYMENT_STATUSES_TEXTS[PAYMENT_STATUS.OVERDUE],
    color: PAYMENT_STATUSES_COLORS[PAYMENT_STATUS.OVERDUE]
  },
  {
    id: PAYMENT_STATUS.CANCELED,
    name: PAYMENT_STATUSES_TEXTS[PAYMENT_STATUS.CANCELED],
    color: PAYMENT_STATUSES_COLORS[PAYMENT_STATUS.CANCELED]
  },
  {
    id: PAYMENT_STATUS.UPCOMING,
    name: PAYMENT_STATUSES_TEXTS[PAYMENT_STATUS.UPCOMING],
    color: PAYMENT_STATUSES_COLORS[PAYMENT_STATUS.UPCOMING]
  },
];
// Estado del calendario: REGULAR receipts vs the count the payment format implies (backend
// PolicyScheduleStatus). Labels live under policies.scheduleStatus.<id>.
export const SCHEDULE_STATUS = {
  COMPLETE: 'COMPLETE',
  INCOMPLETE: 'INCOMPLETE',
  NO_SCHEDULE: 'NO_SCHEDULE',
};
export const SCHEDULE_STATUSES = Object.values(SCHEDULE_STATUS);
export const INVITATION_STATUSES_OPTIONS = [
  {
    id: INVITATION_STATUS.SENT,
    name: INVITATION_STATUSES_TEXTS[INVITATION_STATUS.SENT],
    color: INVITATION_STATUSES_COLORS[INVITATION_STATUS.SENT]
  },
  {
    id: INVITATION_STATUS.SCHEDULED,
    name: INVITATION_STATUSES_TEXTS[INVITATION_STATUS.SCHEDULED],
    color: INVITATION_STATUSES_COLORS[INVITATION_STATUS.SCHEDULED]
  },
  {
    id: INVITATION_STATUS.SENDING,
    name: INVITATION_STATUSES_TEXTS[INVITATION_STATUS.SENDING],
    color: INVITATION_STATUSES_COLORS[INVITATION_STATUS.SENDING]
  },
  {
    id: INVITATION_STATUS.NOT_SENT,
    name: INVITATION_STATUSES_TEXTS[INVITATION_STATUS.NOT_SENT],
    color: INVITATION_STATUSES_COLORS[INVITATION_STATUS.NOT_SENT]
  },
];
export const VALIDITY_PERIOD_TEXTS = {
  month: 'policies.ExpiresIn30Days',
  '3_month': 'policies.ExpiresIn90Days',
  without_end_date: 'policies.ValidityPeriodNotSpecified',
  expired: 'policies.PolicyExpired'
};

// Which provider setting gives each window its length. Doubles as the test for "is this one of
// the two windowed periods", which is why it is exported rather than kept in the panel.
export const RENEWAL_DAYS_FIELD = { month: 'renewals1', '3_month': 'renewals2' };

// Matches FilterSettings' defaults, for the moment before the provider config has loaded.
export const DEFAULT_RENEWAL_DAYS = { month: 30, '3_month': 90 };

// The periods that narrow the result set beyond the date window: they also drop group members
// and settled renewals so the count matches the Renewals board. `without_end_date` does not,
// and must never be labelled as though it did.
export const VALIDITY_PERIODS_WITH_EXCLUSIONS = ['month', '3_month', 'expired'];

export const renewalWindowDays = (period, filterSettings) => (
  filterSettings?.[RENEWAL_DAYS_FIELD[period]] ?? DEFAULT_RENEWAL_DAYS[period]
);

/**
 * The user-facing name of a validity shortcut. Shared by the filter panel (which renders the
 * picker menu) and the view (which renders the chip), so the two can never disagree about what
 * a period is called or how many days wide it is.
 */
export const validityPeriodLabel = (period, t, filterSettings) => {
  const key = VALIDITY_PERIOD_TEXTS[period];
  if (!key) return '';
  return RENEWAL_DAYS_FIELD[period]
    ? t(key, { count: renewalWindowDays(period, filterSettings) })
    : t(key);
};
